import api from '@/services/api';

const BASE = '/v2/agent-skills';

export type SkillScope = 'organization' | 'workspace' | 'personal';

export type AgentSkill = {
  _id: string;
  organizationId: string;
  workspaceId: string | null;
  userId: string | null;
  scope: SkillScope;
  name: string;
  displayName: string;
  description: string;
  whenToUse: string;
  contentMarkdown: string;
  agentTypes: string[];
  isActive: boolean;
  order: number;
  version: number;
  contentHash: string;
  createdAt: string;
  updatedAt: string;
};

export type AgentSkillInput = {
  scope: SkillScope;
  workspaceId?: string;
  name: string;
  displayName: string;
  description: string;
  whenToUse: string;
  contentMarkdown: string;
  agentTypes: string[];
  isActive: boolean;
  order?: number;
};

export const agentSkillsApi = {
  list: async (): Promise<AgentSkill[]> => {
    const { data } = await api.get<AgentSkill[]>(BASE);
    return data;
  },
  create: async (payload: AgentSkillInput): Promise<AgentSkill> => {
    const { data } = await api.post<AgentSkill>(BASE, payload);
    return data;
  },
  update: async (
    id: string,
    payload: Partial<Omit<AgentSkillInput, 'scope' | 'workspaceId' | 'name'>>,
  ): Promise<AgentSkill> => {
    const { data } = await api.patch<AgentSkill>(`${BASE}/${id}`, payload);
    return data;
  },
  delete: async (id: string): Promise<void> => {
    await api.delete(`${BASE}/${id}`);
  },
};
